(function($, undefined) {
	'use strict';

	var initSlider = function() {
		if ($('.slider-com-one-slide').length) {
			$('.slider-com-inner').each(function() {
				var t = $(this);

				t.slick({
					arrows: false,
					dots: true,
					slide: '.slider-com-one-slide',
					slidesToShow: 1,
					slidesToScroll: 1,
					autoplay: true,
					autoplaySpeed: 3000,
					speed: 600
				});
			});
		}
	};

	var init = function() {
		initSlider();
	};
	
	$(window).ready(function () {
		init();
	});

})(jQuery);

